<template>
  <div class="refund_bg text_left">
    <title-bar-back :title="'继续添加'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="cart_list_c">
      <!-- 退款商品店铺 -->
      <div class="font12 font_weight500 colo087 pac_name line_height_18">
        <img
          :src="checkedItemAll ? activeIcon : inactiveIcon"
          alt=""
          class="active_icon"
        />
        <span class="name_name" @click="clickBoxItemAll()">包裹1</span>
      </div>
      <!-- 退款商品信息 -->
      <div v-for="(item, index) in 2" :key="index" class="refund_item">
        <img
          :src="checked ? activeIcon : inactiveIcon"
          class="checkout_img"
          @click="clickBox()"
        />
        <div class="right_width">
          <order-product-list @changeNum="changeNum" />
        </div>
      </div>
    </div>
    <div class="bottom_bor" />
    <!-- <div class="bottom_con clearfix">
      <img
        :src="checkedAll ? activeIcon : inactiveIcon"
        alt=""
        class="checkout_all"
        @click.stop="chooseAll"
      />
      <span class="bot_mar">全选</span>
      <div class="choose_btn right" @click="sureBtn">确定</div>
    </div> -->
    <div
      class="botton_btn text_center font14 font_weight500 colof line_height_50"
      @click="back"
    >
      确定
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
// const CartSection = () =>
//   import('~/components/Cart/CartSection.vue').then(m => m.default || m)
import OrderProductList from "./components/Product";
export default {
  name: "AddProduct",
  components: {
    // CartSection,
    TitleBarBack,
    OrderProductList
  },
  data() {
    return {
      result: [],
      itemResult: {},
      checked: false,
      checkedItemAll: false,
      checkedAll: false,
      activeIcon: require("@/assets/login/select@2x.png"),
      inactiveIcon: require("@/assets/login/unselect@2x.png"),
      detail: {},
      refundProductList: [],
      addList: []
    };
  },
  mounted() {
    // this.detail = JSON.parse(localStorage.REFUND_DETALS)
    // this.detail.shopItems.forEach(a => {
    //   a.refundCkecked = false
    // })
    // console.log(this.detail.shopItems)
    // this.refundProductList = JSON.parse(localStorage.REFUND_PRODUCT_LIST)
  },
  methods: {
    // 顶部返回
    back() {
      this.$router.go(-1);
    },
    // 点击数量
    changeNum() {
      // changeNum(value, product, chooseIndex) {
      // const { shopItems } = this.detail
      // const currentItem = shopItems[chooseIndex]
      // currentItem.modifyQty = value
      // if (value === 0) {
      //   currentItem.refundCkecked = false
      // }
      // this.$set(this.detail.shopItems, chooseIndex, currentItem)
      // this.chooseItem()
    },
    // 单选
    clickBox() {
      // console.log(1111);
      this.checked = !this.checked;
      // clickBox(item, index) {
      // if (item.modifyQty === 0) {
      //   this.$toast('请先选择数量')
      //   return
      // }
      // const { shopItems } = this.detail
      // const currentItem = shopItems[index]
      // currentItem.refundCkecked = !currentItem.refundCkecked
      // this.$set(this.detail.shopItems, index, currentItem)
      // this.chooseItem()
    },
    clickBoxItemAll() {
      // console.log(11111);
      this.checkedItemAll = !this.checkedItemAll;
      // clickBox(item, index) {
      // if (item.modifyQty === 0) {
      //   this.$toast('请先选择数量')
      //   return
      // }
      // const { shopItems } = this.detail
      // const currentItem = shopItems[index]
      // currentItem.refundCkecked = !currentItem.refundCkecked
      // this.$set(this.detail.shopItems, index, currentItem)
      // this.chooseItem()
    },
    // 单选是否全部选中
    chooseItem() {
      // const { shopItems } = this.detail
      // const checkList = shopItems.filter(item => item.refundCkecked)
      // if (checkList && checkList.length === shopItems.length) {
      //   this.checkedAll = true
      // } else {
      //   this.checkedAll = false
      // }
    },
    // 全选按钮
    chooseAll() {
      // const { shopItems } = this.detail
      // if (!this.checkedAll) {
      //   shopItems.forEach(item => {
      //     if (item.modifyQty > 0) {
      //       item.refundCkecked = true
      //     }
      //   })
      //   const allCheck = shopItems.filter(item => item.refundCkecked)
      //   if (allCheck.length === shopItems.length) {
      //     this.checkedAll = true
      //   } else {
      //     this.checkedAll = false
      //   }
      // } else {
      //   shopItems.forEach(item => {
      //     item.refundCkecked = false
      //   })
      //   this.checkedAll = false
      // }
      this.checkedAll = !this.checkedAll;
    },
    // 确定按钮
    sureBtn() {
      // const { shopItems } = this.detail
      // const checkList = shopItems.filter(item => {
      //   if (item.modifyQty && item.modifyQty !== 0) {
      //     return item.refundCkecked && item.modifyQty > 0
      //   } else {
      //     return item.refundCkecked && item.supportAfterSaleAmount > 0
      //   }
      // })
      // if (!(checkList && checkList.length)) {
      //   this.$toast('请先选择商品')
      //   return
      // }
      // localStorage.REFUND_PRODUCT_LIST = JSON.stringify(checkList)
      // localStorage.REFUND_DETALS = JSON.stringify(this.detail)
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.refund_bg {
  /* margin-top: 40px; */
}
/* 侧滑 */
.cart_list_c {
  background: #fff;
  border-radius: 10px;
}
.pac_name {
  padding: 20px 12px;
}
.active_icon {
  width: 18px;
  margin-right: 8px;
  vertical-align: middle;
}
.name_name {
  vertical-align: middle;
}
.right_delete {
  background: rgba(242, 11, 0, 1);
  height: 100%;
  width: 64px;
  cursor: pointer;
}
.right_delete_btn {
  position: absolute;
  width: 100%;
  top: 50%;
  margin-top: -25%;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
.refund_item {
  display: flex;
  align-items: center;
}
.right_width {
  width: 100%;
  margin-right: 12px;
}
.bottom_bor {
  height: 60px;
}
/* 底部按钮 */
/* .bottom_con {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 5px 15px;
}
.checkout_all {
  width: 20px;
  height: 20px;
  margin-top: 10px;
}
.bot_mar {
  margin: 12px 0 0 5px;
}
.choose_btn {
  background: linear-gradient(
    270deg,
    rgba(251, 214, 146, 1) 0%,
    rgba(224, 175, 101, 1) 100%
  );
  border-radius: 20px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 40px;
  padding: 0 40px;
} */
.checkout_img {
  width: 18px;
  height: 18px;
  padding: 0 12px;
}
.botton_btn {
  position: fixed;
  bottom: 8px;
  left: 0;
  right: 0;
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 2px;
  margin: 0 12px;
}
</style>
